const loadingDefault = 5 // loading默认5秒
const requestIdEnum = {
  addCar: 'addCar', // 维修接车 - 新增
  updateCar: 'updateCar', // 维修接车 - 编辑
  acceptCar: 'acceptCar', // 维修接车 - 新增/编辑
  car: 'car', // 车辆管理 - 新增/编辑
  material: 'material', // 配件 - 新增/编辑
  workingHour: 'workingHour', // 工时服务 - 新增/编辑
  cancel: 'cancel' // 作废
}

// 车辆燃油类型：0汽油，1柴油，2天然气，3混合油，4液化石油气，5甲醇，6乙醇，7混合动力，8纯电动，9其他
const carOilTypeEnum = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
// 尾气燃油类型：1柴油，2汽油，3天然气，4混合油，5液化石油气，6甲醇，7乙醇，8混合动力，9纯电动，10其他
const gasOilTypeEnum = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

// app download url
const urls = new Map([
  ['dev', { pc: 'http://gip-dev.ob.ym', app: 'http://gipapp-dev.ob.ym/' }],
  ['test', { pc: 'http://gip.test.iauto360.cn', app: 'https://gipapp.test.iauto360.cn/' }],
  ['prod', { pc: 'http://gip.iauto360.cn', app: 'https://gipapp.iauto360.cn/' }]
])
const urlPrepend = '#/appdownload'

// plateNumber info
const cars = {
  colors: ['蓝色', '黄色', '白色', '绿色', '黄绿', '农黄', '渐变绿', '黑色', '其他'],
  provinces: ['新车', '新疆'].concat('架京津沪渝冀豫云辽黑湘皖鲁苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领转进亚注新'
    .split('')),
  // regExp: /^((([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领转进亚注]|新\(新疆\)|新\(新车\)|新疆|新车)[A-Z0-9](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领转进亚注]|新\(新疆\)|新\(新车\)|新疆|新车)[A-Z0-9][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/,
  // 临时开放车牌校验规则，上方才是较标准规则
  regExp: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领转进亚注]|新\(新疆\)|新\(新车\)|新疆|新车)[A-Z0-9]{5,8}[A-Z0-9挂学警港澳使领]$/,
  regExpNoProvince: /^[晋]?(([A-Z0-9](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([A-Z0-9][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/
}

// I站尾气接口key
const gasIKeys1 = ['lscoresult', 'lshcresult', 'lambdaxzhdown', 'hscoresult', 'hshcresult', 'lambdaxzhup']
const gasIKeys2 = ['co2540', 'hc2540', 'no2540', 'co5025', 'hc5025', 'no5025']
const gasIKeys3 = ['smokeavg', 'ratedSpeed', 'actualSpeed']
const gasIKeys4 = ['k100', 'k80', 'nox80', 'ratedSpeed', 'actualSpeed']
const gasIKeys5 = ['vmasHc', 'vmasCo', 'vmasNox']
const gasIKeys6 = ['rigelManValue']
const gasIKeys = [...gasIKeys1, ...gasIKeys2, ...gasIKeys3, ...gasIKeys4, ...gasIKeys5, ...gasIKeys6]

// M站尾气参考值
const gas = {
  standard: {
    car: {
      co: '≤ 0.2',
      hc: '≤ 50',
      no: '≤ 65',
      co2: '≥ 13',
      o2: '≤ 1.0',
      ratio: '0.97 ≤ λ ≤ 1.03'
    },
    diesel: {
      k: '< 1.2',
      NOX: '≤ 1500'
    }
  }
}

// 纸张打印方向 direction: 'landscape' | 'portrait'
const print = {
  direction: '<style type="text/css" media="print">\n' + '  @page { size: direction; }\n' + '</style>',
  key: 'direction',
  keys: ['landscape', 'portrait']
}

// 配件编辑 material 字段
const materialData = {
  materialId: '', // 配件ID 编辑
  materialName: '', // 配件名
  brand: '', // 品牌
  model: '', // 型号
  price: '', // 单价
  remark: '', // 备注
  costPrice: '', // 成本价
  limitPrice: '', // 限价
  specification: '', // 规格
  unit: '', // 单位
  status: 1 // 状态
}

// 缺省页
const missingPages = new Map([
  ['noData', { key: 0, path: 'no_data.png' }],
  ['dataWrong', { key: 1, path: 'data_wrong.png' }],
  ['noList', { key: 2, path: 'no_list.png' }],
  ['netError', { key: 3, path: 'net_error.png' }],
  ['systemError', { key: 4, path: 'system_error.png' }]
])
const missingPagesKeys = [...missingPages.keys()]

// 首页图标
const homeIcons = new Map([
  ['order', { key: 0, path: 'today_order.svg' }],
  ['repair', { key: 1, path: 'today_repair.svg' }],
  ['repairGas', { key: 2, path: 'today_repair_gas.svg' }],
  ['pay', { key: 3, path: 'today_pay.svg' }],
  ['upload', { key: 4, path: 'today_upload.svg' }],
  ['print', { key: 5, path: 'today_print.svg' }]
])
const homeIconsKeys = [...homeIcons.keys()]

// 设备类型: 4,5暂时不显示在下拉列表
const deviceType = [
  { key: '1', name: '汽油' },
  { key: '2', name: '柴油' },
  { key: '3', name: '汽柴一体' }
  // { key: 4, name: 'DPF清洗机' },
  // { key: 5, name: 'DPF清洗机零售版' }
]

export {
  loadingDefault,
  requestIdEnum,
  carOilTypeEnum,
  gasOilTypeEnum,
  urls,
  urlPrepend,
  cars,
  gasIKeys,
  gas,
  print,
  materialData,
  missingPages,
  missingPagesKeys,
  homeIcons,
  homeIconsKeys,
  deviceType
}



// WEBPACK FOOTER //
// ./src/libs/const.js